<template>
  <div class="post-login" dir="rtl">
    <v-dialog v-model="dialog1" class="post-login-dialog">
      <v-card class="post-login-dialog-card">
        <v-card-title>
          {{ $t('savePassword') }}
          <img src="../../../public/img/zoodkomak.png">
        </v-card-title>

        <v-card-text>
          <div class="choose-select">
            <v-select
              :items="items"
              :label="$t('choose')"
              item-text="label"
              item-value="value"
              single-line
            >
            </v-select>
          </div>
          <div class="relative">

            <v-text-field
              :label="$t('password')"
              single-line
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="relative">

            <v-text-field
              :label="$t('repeatPassword')"
              single-line
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="row">
            <div class="col-6">
              <button type="submit" class="save-btn">{{ $t('ok') }}</button>
            </div>
            <div class="col-6">
              <button class="cancle-btn" @click="dialog1 = false">{{ $t('cancel') }}</button>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2">
      <v-card class="post-login-dialog-card">
        <v-card-title>
          {{ $t('savePassword') }}
          <img src="../../../public/img/zoodkomak.png">
        </v-card-title>
        <v-card-text>
          <div class="choose-select">
            <v-select
              :items="items"
              :label="$t('choose')"
              item-text="label"
              item-value="value"
              single-line
            >
            </v-select>
          </div>
          <div class="relative">

            <v-text-field
              :label="$t('password')"
              single-line
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="relative">

            <v-text-field
              :label="$t('repeatPassword')"
              single-line
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="row">
            <div class="col-6">
              <button type="submit" class="save-btn">{{ $t('ok') }}</button>
            </div>
            <div class="col-6">
              <button class="cancle-btn" @click="dialog1 = false">{{ $t('cancel') }}</button>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="square"></div>
    <div class="login-card-outer">
<!--      <v-form-->
<!--        ref="form"-->
<!--        v-model="valid"-->
<!--      >-->
        <div class="login-card">
          <img src="../../../public/img/zoodkomak.png">
          <div class="choose-select">
            <v-select
              :items="items"
              item-text="label"
              item-value="value"
              :label="$t('choose')"
              single-line
              v-model="selected_party"
            >
            </v-select>
          </div>
          <div class="relative">
            <v-icon>
              mdi-account
            </v-icon>
            <v-text-field
              :label="$t('password')"
              type="password"
              single-line
              v-model="party_password"
            ></v-text-field>
          </div>

          <div class="relative">
            <v-icon>
              mdi-cellphone-iphone

            </v-icon>
            <v-text-field
              :label="$t('internalNumber')"
              single-line
            ></v-text-field>
          </div>
          <div>
            <button class="btn login-btn" v-on:click="party_login()">
              {{ $t('loginWithRols') }}
            </button>
          </div>
          <div class="row">
            <div class="col-6">
              <button class="login-pass-btn" v-on:click="dialog1 = true">
                {{ $t('createPassword') }}
              </button>
            </div>
            <div class="col-6">
              <button class="login-pass-btn" v-on:click="dialog2 = true">
                {{ $t('forgotPassword') }}
              </button>
            </div>
          </div>
        </div>
<!--      </v-form>-->

    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  export default {
    data() {
      return {
        errors: [],
        mobile: '',
        fullName: '',
        dialog1: false,
        dialog2: false,
        items: [],
        valid: true,
        selected_party: 0,
        party_password: '',
        rules: {
          required: value => !!value || this.$t('necessary'),
          fullName: value => value.length <= 30 || this.$t('max30Character'),
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('phoneNotCorrect')
          },
        },
      }
    }, mounted() {
      this.get_posts();
    },
    methods: {

      get_posts() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        console.log();
        const send_data = {
          "UserId": user_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserParties', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.parties.forEach(function (number) {
                console.log(number.PartyName);
                var obj = {label: number.PartyName, value: number.Id}
                self.items.push(obj);
              });
              // response.data.parties.forEach(function(item) {
              //   console.log("sdsd"+item)
              //
              // });


            }
          }).catch(e => {
          this.errors.push(e);

        })

      },
      party_login() {
        if (this.mobile == "") {
          this.errors.push(this.$t('pleaseEnterYourNo'))
        }
        if (this.fullName == "") {
          this.errors.push(this.$t('enterYourNameLastName'))
        }
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        console.log();
        const send_data = {
          "UserId": user_id,
          "pass": self.party_password,
          "PartyId": self.selected_party,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/LoginByPartyId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              localStorage.setItem("party_id", response.data.partyId);
              self.$router.push({path: "/home-tab", params: {}});


            }
          }).catch(e => {
          this.errors.push(e);

        })

      }
    }
  }
</script>
